<template>
  <div>
    <banner />
    <div class="absolutecont">
      <div class="web">
        <div class="commonbg">
          <tab cur="/gaodiyadianji" />
          <div class="ProductImages">
            <img :src="baseApi+ 'upload/product/5001.png'">
            <img :src="baseApi+ 'upload/product/5002.png'">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '@/views/view/componets/Banner'
import Tab from '@/views/view/componets/Tab'
export default {
  components: { Banner, Tab },
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/'
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.ProductImages {
  padding: 30px;
  img {
    max-width: 100%;
    margin: 20px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/view/gaodiyadianji.vue